import { ADD_NOTIFICATION, SET_NOTIFICATIONS } from '../../constants/ActionTypes';
import { QuestionEnum } from '@helpers/enums';
import { getNotifications, setNotifications, setPendingNotifications } from '@helpers/utils';
import { IDataReducer } from '../../models/generals/iDataReducer';
import { INotification } from '../../models/utilities/iNotification';

const INIT_STATE = {
  notificationList: getNotifications(),
};

export default (state = INIT_STATE, action: IDataReducer) => {
  let pendingNotifications: number = 0;
  switch (action.type) {
    case SET_NOTIFICATIONS:
      setNotifications(action.notifications);
      if (action.notifications && action.notifications.length > 0) {
        pendingNotifications =
          action.notifications.filter(
            (notification) =>
              notification.users &&
              notification.users.length > 0 &&
              notification.users[0].pivot &&
              notification.users[0].pivot.read === QuestionEnum.NO,
          ).length ?? 0;
      }
      setPendingNotifications(pendingNotifications);
      return { ...state, notificationList: action.notifications, pendingNotifications: pendingNotifications };

    case ADD_NOTIFICATION:
      let newNotifications: INotification[] = getNotifications();
      if (action.notification) {
        newNotifications.unshift(action.notification);
        if (newNotifications.length > 0) {
          pendingNotifications =
            newNotifications.filter(
              (notification) =>
                notification.users &&
                notification.users.length > 0 &&
                notification.users[0].pivot &&
                notification.users[0].pivot.read === QuestionEnum.NO,
            ).length ?? 0;
        }
      }
      setNotifications(newNotifications);
      setPendingNotifications(pendingNotifications);
      return {
        ...state,
        notificationList: newNotifications,
        pendingNotifications: pendingNotifications,
      };

    default:
      return state;
  }
};
